/* Native single-kit configurator. Exact variant IDs/prices; no client-priced bundles. */
(() => {
  'use strict';
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    let data;
    try { data = JSON.parse(root.querySelector('[data-builder-json]').textContent); }
    catch (_) { root.querySelector('[data-status]').textContent = 'Could not load options. Please reload.'; return; }
    const $ = s => root.querySelector(s);
    const all = s => [...root.querySelectorAll(s)];
    const spec = data.specs;
    let width = '', height = '', busy = false, uncertain = false;
    const status = $('[data-status]');
    function selected() { return data.variants.find(v => v.options[0] === height && v.options[1] === width); }
    function setText(s, text) { const node = $(s); if (node) node.textContent = text; }
    function svgElement(name, attrs, text) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', name);
      Object.entries(attrs).forEach(([k,v]) => el.setAttribute(k, String(v)));
      if (text) el.textContent = text;
      return el;
    }
    function diagram(w, h) {
      const svg = $('[data-diagram]');
      const n = w ? w.sections : 1, abbreviated = !!w && n > 4;
      // Supplier reference: actual min-max range, not height order or max-height threshold.
      const collarCounts={'4-7':1,'5-8':1,'6-10':1,'7-12':1,'8-14':1,'9-16':1,'10-18':1,'6-14':2,'7-17':2,'8-20':2,'9-23':2,'10-26':2};
      const collars=h?.kind==='Adjustable'?(collarCounts[`${h.min}-${h.max}`]||0):0;
      svg.dataset.collarsPerUpright=String(collars);
      const omitted = abbreviated ? n - 4 : 0;
      const y = h ? 205 - (h.max / 20) * 135 : 115;
      const titleID = `${root.getAttribute('aria-labelledby')}-diagram-title`;
      const descID = `${titleID}-description`;
      const caption = !w ? 'Choose a width to see your layout.' : abbreviated
        ? `4 of ${n} sections shown · ${omitted} middle sections omitted. One continuous straight run.`
        : `All ${n} connected ${n === 1 ? 'section is' : 'sections are'} shown.`;
      svg.replaceChildren();
      svg.setAttribute('aria-labelledby', `${titleID} ${descID}`);
      svg.removeAttribute('aria-label');
      svg.dataset.abbreviated = String(abbreviated);
      svg.dataset.totalSections = w ? String(n) : '';
      svg.dataset.shownSections = w ? String(abbreviated ? 4 : n) : '';
      svg.append(svgElement('title', {id:titleID}, w ? `${n} connected straight sections. ${w.min} to ${w.max} feet overall width. ${h ? h.label : 'Height not selected'}.` : 'Choose a width and height to plan a straight backdrop.'));
      svg.append(svgElement('desc', {id:descID}, `${w ? `Full kit: ${n} crossbars, ${n+1} uprights and ${n+1} bases with pins. ` : ''}${caption} Hardware only; no fabric included or pictured. Schematic, not to scale. The visual break is not a physical gap.`));
      const text = (x,y,label,size=18,weight=400) => svgElement('text',{x,y,'text-anchor':'middle',fill:'#283d47','font-size':size,'font-weight':weight},label);
      function run(xs) {
        svg.append(svgElement('line',{x1:xs[0]-18,y1:220,x2:xs[xs.length-1]+18,y2:220,stroke:'#d7ddd9','stroke-width':1}));
        xs.forEach((x,i) => {
          svg.append(svgElement('rect',{'data-diagram-base':'',x:x-11,y:213,width:22,height:7,rx:1,fill:'#69777b'}));
          svg.append(svgElement('line',{'data-diagram-upright':'',x1:x,y1:213,x2:x,y2:y,stroke:'#52636b','stroke-width':4}));
          for(const fraction of collars===2?[0.36,0.68]:collars===1?[0.53]:[]) {
            svg.append(svgElement('rect',{'data-diagram-collar':'',x:x-5,y:y+(213-y)*fraction-3.5,width:10,height:7,fill:'#171b1d',rx:1}));
          }
          if (i<xs.length-1) svg.append(svgElement('line',{'data-diagram-bay':'',x1:x,y1:y+3,x2:xs[i+1],y2:y+3,stroke:'#7e9198','stroke-width':4}));
        });
      }
      if (abbreviated) {
        run([50,147,244]);
        run([356,453,550]);
        // A deliberate drawing break, never an installed gap or a second setup.
        [267,333].forEach(x => svg.append(svgElement('path',{d:`M ${x-7} ${y-7} l 14 20 M ${x-7} 201 l 14 20`,fill:'none',stroke:'#a3543d','stroke-width':3})));
        svg.append(text(300,140,`+${omitted}`,26,650));
        svg.append(text(300,162,omitted===1?'section':'sections',16));
        svg.append(text(300,181,'omitted',16));
        svg.append(text(300,255,'2 sections shown at each end',18));
      } else {
        run(Array.from({length:n+1},(_,i)=>65+i*470/n));
        svg.append(text(300,255,w?`${n} ${n===1?'section':'sections'} · full layout shown`:'Illustrative hardware',18));
      }
      svg.append(text(300,35,h?`${h.label} high`:'Choose your height',20));
      const widthLabel = $('[data-diagram-width]'), countLabel = $('[data-diagram-count]'), note = $('[data-diagram-caption]');
      if(widthLabel) widthLabel.textContent=w?`${w.min}–${w.max} ft`:'Choose your width';
      if(countLabel) countLabel.textContent=w?`${n} connected ${n===1?'section':'sections'} total`:'Your complete straight layout';
      if(note) note.textContent=caption;
    }
    function writeURL() {
      const u=new URL(location.href), v=selected();
      ['variant','bw','bh'].forEach(k=>u.searchParams.delete(k));
      if(v) u.searchParams.set('variant',v.id);
      else { if(width)u.searchParams.set('bw',String(spec.widths.findIndex(w=>w.value===width)));if(height)u.searchParams.set('bh',String(spec.heights.findIndex(h=>h.value===height))); }
      if(u.href!==location.href)history.pushState({},'',u);
    }
    function render(push=false) {
      const w=spec.widths.find(x=>x.value===width), h=spec.heights.find(x=>x.value===height), v=selected();
      all('input[name="builder-width"]').forEach(i=>i.checked=i.value===width);
      all('input[name="builder-height"]').forEach(i=>i.checked=i.value===height);
      // Disable only impossible combinations, never valid sold-out variants.
      all('input[name="builder-height"]').forEach(i=>{i.disabled=!!width&&!data.variants.some(v=>v.options[0]===i.value&&v.options[1]===width);});
      all('input[name="builder-width"]').forEach(i=>{i.disabled=!!height&&!data.variants.some(v=>v.options[0]===height&&v.options[1]===i.value);});
      setText('[data-width-summary]',w?`${w.min}–${w.max} ft · ${w.sections} ${w.sections===1?'section':'sections'}`:'Choose your width');
      setText('[data-height-summary]',h?h.label:'Choose your height');
      const included = $('[data-included-items]');
      if (included) {
        included.replaceChildren();
        if (w && h && v) {
          const rows = [
            [`${w.sections+1} uprights`, `${h.label} · ${h.kind.toLowerCase()}`],
            [`${w.sections} ${w.sections===1?'crossbar':'crossbars'}`, `${w.min/w.sections}–${w.max/w.sections} ft adjustable width each`],
            [`${w.sections+1} bases`, h.base],
            [`${w.sections+1} base pins`, h.pin]
          ];
          rows.forEach(([name, size]) => {
            const li = document.createElement('li'), strong = document.createElement('strong'), detail = document.createElement('span');
            strong.textContent = name; detail.textContent = size;
            li.append(strong, detail); included.append(li);
          });
        }
      }
      setText('[data-included]',w&&h&&v?`${w.sections} ${w.sections===1?'section':'sections'} · hardware quantities & sizes`:'Choose your configuration');
      setText('[data-included-state]',w&&h&&v?`${w.min}–${w.max} ft overall width · ${h.label} high`:'Choose a width and height to see the exact hardware quantities and sizes.');
      setText('[data-base]',h?`Included base: ${h.base}. Pin: ${h.pin}.`:'Choose a height for base & pin dimensions.');
      setText('[data-price]',v?v.formattedPrice:'Choose size for price');
      setText('[data-dock-price]',v?v.formattedPrice:'Choose your size');
      setText('[data-sku]',v?`SKU: ${v.sku||'Not assigned'} · One complete hardware kit`:'One complete hardware kit');
      $('[name="id"]').value=v?v.id:'';
      $('[data-width-options]').disabled=busy||uncertain;
      $('[data-height-options]').disabled=busy||uncertain;
      const canAdd=!!v&&v.available&&data.commerce&&v.minimum===1&&v.increment===1&&!busy&&!uncertain;
      $('[data-add]').disabled=!canAdd;
      $('[data-add]').textContent=busy?'Checking your kit…':uncertain?'Check your cart before retrying':!v?'Choose width & height':!data.commerce?'Add hardware kit':!v.available?'Sold out':'Add hardware kit to cart';
      status.textContent=!width||!height?'Choose width and height.':!v?'This combination is not offered. Change your width or height.':!data.commerce?`Unavailable.`:!v.available?'Sold out.':'Drapery is not included.';
      if(v&&v.image){$('[data-photo]').src=v.image;$('[data-photo-link]').href=v.image;}
      diagram(w,h);
      root.dataset.variant=v?v.id:'';
      root.dataset.state=!width||!height?'incomplete':!v?'impossible':v.available?'available':'soldout';
      if(push)writeURL();
    }
    function readURL() {
      const u=new URL(location.href),id=u.searchParams.get('variant'),v=data.variants.find(x=>x.id===id);
      width='';height='';
      if(v){height=v.options[0];width=v.options[1];}
      else {
        const wi=u.searchParams.get('bw'),hi=u.searchParams.get('bh');
        if(wi!==null&&/^\d+$/.test(wi)&&spec.widths[Number(wi)])width=spec.widths[Number(wi)].value;
        if(hi!==null&&/^\d+$/.test(hi)&&spec.heights[Number(hi)])height=spec.heights[Number(hi)].value;
      }
      render();
      if(id&&!v)status.textContent='That variant link is not part of this kit. Choose a supported width and height.';
    }
    root.addEventListener('change',e=>{
      if(e.target.name==='builder-width')width=e.target.value;
      else if(e.target.name==='builder-height')height=e.target.value;
      else return;
      if(!busy&&!uncertain)render(true);
    });
    all('[data-change]').forEach(b=>b.addEventListener('click',()=>{
      const target=b.dataset.change==='width'?$('[data-width-options]'):$('[data-height-options]');
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});
      (target.querySelector('input:checked')||target.querySelector('input:not(:disabled)')).focus({preventScroll:true});
    }));
    $('[data-review]').addEventListener('click',()=>{$('[data-summary]').scrollIntoView({block:'center'});$('[data-summary]').focus({preventScroll:true});});
    $('[data-reset]').addEventListener('click',()=>{if(busy||uncertain)return;width='';height='';render(true);$('[data-width-options] input').focus();});
    $('[data-kit-form]').addEventListener('submit',async e=>{
      e.preventDefault();const v=selected();
      if(busy||uncertain||!data.commerce||!v||!v.available||v.minimum!==1||v.increment!==1)return;
      busy=true;render();let posted=false;
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),15000);
      try {
        const check=await fetch(data.productURL+'.js',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if(!check.ok)throw Error('Could not recheck this kit. Nothing was added. Please try again.');
        const fresh=await check.json(),live=fresh.variants.find(x=>String(x.id)===v.id);
        if(!live||!live.available||live.price!==v.price||live.quantity_rule&&(live.quantity_rule.min!==1||live.quantity_rule.increment!==1))throw Error('Price or availability changed. Nothing was added. Reload to review the current kit.');
        posted=true;
        const response=await fetch(data.addURL,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1}]}),signal:controller.signal});
        if(!response.ok){
          if(response.status===422){posted=false;throw Error('This kit cannot be added at the moment. Nothing was added. Please reload to check availability.');}
          throw Error('The cart response could not be confirmed. Check your cart before trying again.');
        }
        const result=await response.json();
        if(!result.items||result.items.length!==1||String(result.items[0].variant_id||result.items[0].id)!==v.id)throw Error('The cart response could not be confirmed. Check your cart before trying again.');
        uncertain=true;status.textContent='Kit added. Opening your cart…';location.assign(data.cartURL);
      } catch(error) {
        uncertain=posted;
        busy=false;render();
        status.textContent=posted?'The request may have reached your cart. Check your cart before retrying to avoid a duplicate.':error.name==='AbortError'?'The availability check timed out. Nothing was added; please try again.':error.message;
        $('[data-cart-check]').hidden=!posted;
        status.focus();
      } finally {clearTimeout(timer);busy=false;if(uncertain)$('[data-add]').disabled=true;}
    });
    window.addEventListener('popstate',readURL);
    readURL();
    root.classList.add('builder-ready');
    $('[data-controls]').hidden=false;
  }
  const mount=()=>document.querySelectorAll('[data-backdrop-builder]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
  document.addEventListener('shopify:section:load',mount);
})();
